import { render } from "./InnerHeader.vue?vue&type=template&id=2283a0b8&ts=true"
import script from "./InnerHeader.vue?vue&type=script&lang=ts"
export * from "./InnerHeader.vue?vue&type=script&lang=ts"

import "./InnerHeader.vue?vue&type=style&index=0&id=2283a0b8&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__